export default "__VITE_ASSET__DJ0Q1k2J__"